// extracted by mini-css-extract-plugin
module.exports = {"titleShadow":"_3iFwLXc4LR_JgeFyhvAxFX"};